export default __webpack_public_path__ + "faa970a320312f92b900ff50585e480e.png";